var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('div',{staticClass:"timer__number"},[_vm._v(_vm._s(_vm.displayNumber))]),_c('div',{staticClass:"timer__label"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }